module.exports = __webpack_public_path__ + "static/media/signup_screen.eb5a4cf9.jpg";